import React from 'react';
import { Text } from '@rsos/base-components';
import { disabledAlertTypes } from './utils';

const Disclaimer = ({ availableAlertTypes }) => {
  let res = [];

  availableAlertTypes.forEach(a => {
    if (disabledAlertTypes.includes(a.name)) {
      res.push(`${a?.display_name}`.replace('Alerts', '').trim());
    }
  });
  if (res.length === 0) {
    return null;
  }

  return (
    <Text style={{ fontSize: '8px' }} mt="8px">
      {res.join(' and ')} notifications will always be enabled.
    </Text>
  );
};

export default Disclaimer;
